// Slug helpers — used for SEO-friendly country URLs (e.g. /country/france,
// /country/south-korea, /country/united-states).
//
// We derive the slug from country.name so the URL stays human-readable
// even when ISO codes change (uk → gb etc). The reverse lookup is O(n) but
// the atlas is small (~53 entries) so this is fine.

import { COUNTRIES } from "@/data/countries";

export function slugify(text) {
  if (!text) return "";
  return String(text)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics (Brasília → brasilia)
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Returns the SEO slug for a country (e.g. "south-korea" for South Korea).
export function countrySlug(country) {
  if (!country) return "";
  return slugify(country.name);
}

// Reverse lookup: find a country by its SEO slug. Returns undefined if not found.
export function countryBySlug(slug) {
  if (!slug) return undefined;
  const target = slug.toLowerCase();
  return COUNTRIES.find((c) => slugify(c.name) === target);
}

// All country slugs — used by sitemap + prerender scripts.
export function allCountrySlugs() {
  return COUNTRIES.map((c) => slugify(c.name));
}
